import { capitalize } from '@susu/string'

export const translateName = (languageCode: string) => {
  return capitalize(
    String(
      new Intl.DisplayNames([languageCode], {
        type: 'language',
      }).of(languageCode),
    ),
  )
}
